import { useHistory } from 'react-router';
import { useWeb3React } from '@web3-react/core';
import { Web3Provider } from '@ethersproject/providers';
import { ethers } from 'ethers';
import { motion } from 'framer-motion';
import PlayerIcon from '../Utils/PlayerIcon';

interface IProps {
  gameData: {
    address: string;
    players: {
      player1: string;
      player2: string | undefined;
    };
    winnerScore: number;
    fieldLength: number;
  };
}

// shorten the name of the player
const shorter = (str: any) =>
  str?.length > 8 ? `${str.slice(0, 5)}...${str.slice(-4)}` : str;

const TnCLobbyJoin: React.FC<IProps> = ({ gameData }: IProps) => {
  // states and contexts
  const { account } = useWeb3React<Web3Provider>();
  const history = useHistory();

  // UI functions
  const onJoin = async (address: string) => {
    if (account) {
      history.push(`/tncgame/${address}`);
    }
  };

  return (
    <motion.div
      key={gameData.address}
      variants={{
        open: {
          opacity: 1,
          width: 'auto',
          transition: {
            duration: 1.2,
            ease: 'easeInOut',
            delayChildren: 0.2,
            staggerChildren: 0.2
          }
        },
        collapsed: { opacity: 0, width: '0px' }
      }}
    >
      <div className="tncLobbyJoinContainer">
        <motion.div
          key={`${gameData.address}-tncLobbyJoinContentPlayer1`}
          variants={{
            open: { opacity: 1 },
            collapsed: { opacity: 0 }
          }}
        >
          <div className="playerWrapper">
            <div className="playerIcon">
              <PlayerIcon active={gameData.players.player1 === account} />
            </div>
            <div
              className="playerText"
              style={{
                color:
                  gameData.players.player1 === account ? '#f8f8f8' : '#d3d3d3'
              }}
            >
              {gameData.players.player1 !== ethers.constants.AddressZero
                ? shorter(gameData.players.player1)
                : '-'}
            </div>
          </div>
        </motion.div>
        <motion.div
          key={`${gameData.address}-tncLobbyJoinContentPlayer2`}
          variants={{
            open: { opacity: 1 },
            collapsed: { opacity: 0 }
          }}
        >
          <div className="playerWrapper">
            <div className="playerIcon">
              <PlayerIcon active={gameData.players.player2 === account} />
            </div>
            <div
              className="playerText"
              style={{
                color:
                  gameData.players.player2 === account ? '#f8f8f8' : '#d3d3d3'
              }}
            >
              {gameData.players.player2 !== ethers.constants.AddressZero
                ? shorter(gameData.players.player2)
                : '-'}
            </div>
          </div>
        </motion.div>
        <motion.div
          key={`${gameData.address}-tncLobbyJoinContentWinScore`}
          variants={{
            open: { opacity: 1 },
            collapsed: { opacity: 0 }
          }}
        >
          <div className="tncLobbyJoinInfoWrapper">
            <span className="tncLobbyJoinInfoText">WIN</span>
            <span className="tncLobbyJoinInfoValue">
              {gameData.winnerScore}
            </span>
          </div>
        </motion.div>
        <motion.div
          key={`${gameData.address}-tncLobbyJoinContentFieldLength`}
          variants={{
            open: { opacity: 1 },
            collapsed: { opacity: 0 }
          }}
        >
          <div className="tncLobbyJoinInfoWrapper">
            <span className="tncLobbyJoinInfoText">LENGTH</span>
            <div className="tncLobbyJoinInfoValueContainer">
              <span className="tncLobbyJoinInfoValue">
                {Math.round(gameData.fieldLength / 1000)}
              </span>
            </div>
          </div>
        </motion.div>
        <motion.div
          key={`${gameData.address}-tncLobbyJoinContentJoinButton`}
          variants={{
            open: { opacity: 1 },
            collapsed: { opacity: 0 }
          }}
        >
          <button
            type="button"
            className="tncLobbyJoinButton"
            onClick={() => onJoin(gameData.address)}
            disabled={!account}
          >
            +
          </button>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default TnCLobbyJoin;
